import { connect } from 'react-redux';
import PurchaseRequest from '../../../components/event/purchase-request';
import { setEventSuccessMessage, clearAllErrors } from '../../../actions';
import { getPrLoading } from '../../../reducers';

const mapStateToProps = state => ({
    status: state.events.status,
    eventId: state.events.id,
    contract: state.forms.event.contract,
    successMessage: state.events.successMessage,
    errorMessage: state.events.errorMessage,
    eventName: state.events.name,
    eventSaveSubmit: state.events.eventSaveSubmit,
    prSaveSubmit: state.events.prSaveSubmit,
    prAccessible: state.events.prAccessible,
    startDate: state.events.startDate,
    purchaseRequestId: state.PurchaseRequest.id,
    getPrLoading: getPrLoading(state)
});

const mapDispatchToProps = dispatch => ({
    clearMessage: () => dispatch(setEventSuccessMessage(null)),
    clearAllErrors: () => dispatch(clearAllErrors())
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseRequest);



// WEBPACK FOOTER //
// ./src/containers/event/purchase-request/index.js